import { API_BUILDING, API_BUILDING_TREE } from "@/configs/Apis";
import { Fetcher as Ajax } from "@/utils/Request";
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";
import { Module } from "vuex";
import baseModule from "./common";

const newModule: Module<any, any> = merge(cloneDeep(baseModule), {
  actions: {
    getBuildingTree({ commit }: any) {
      return Ajax.queryData(API_BUILDING_TREE, {}, "GET", false)
        .then(data => {
          let count = 0;
          function execCount(item: any) {
            if (item && item.children) {
              item.children.forEach((child: any) => {
                count += child.count;
              });
            }
          }
          if (data && data.length) {
            execCount(data[0]);
          }
          commit(
            "setBuildingTree",
            [
              {
                title: "全部",
                count: count,
                icon: "all-data",
                buildingFilter: {}
              }
            ].concat(data[0].children)
          );
        })
        .catch(() => {
          commit("setBuildingTree", [
            {
              title: "全部",
              count: 0,
              icon: "all-data",
              buildingFilter: {}
            }
          ]);
        });
    },
    addBuilding(store: any, payload: any) {
      return Ajax.saveData(API_BUILDING, payload, "POST");
    },
    updateBuilding(store: any, payload: any) {
      return Ajax.saveData(API_BUILDING + "/" + payload.id, payload, "PUT");
    },
    deleteBuilding(store: any, filter: any) {
      return Ajax.saveData(API_BUILDING, filter, "DELETE");
    }
  },
  mutations: {
    setBuildingTree(state: any, data: any) {
      state.buildingTree = data;
    }
  }
});

const oldState = newModule.state as () => Object;

newModule.state = () => ({ ...oldState(), buildingTree: null });

export default newModule;
